/* eslint-disable eqeqeq */
import { SyncOutlined } from "@ant-design/icons";
import axios from "axios";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { agentSchema } from "../../components/validation/Schema";
import { addAgent } from "../../redux/admin/actions/admin.actions";
import style from "./Update.module.scss";

const CreateForm = (props) => {
  const dispatch = useDispatch();
  const baseUrl = "https://lab.lifebank.ng/labx/api/v1/auth/user/state/Nigeria";

  const [stateOptionDropDown, setstateOptionDropDown] = useState();
  const [selectedStateOfOriginId, setselectedStateOfOriginId] = useState();
  const [value, setValue] = useState('');
  const options = ["Select User", "Customer care", "Ops", "Admin"]

  useEffect(() => {
    const fetchData = () => {
      axios.get(baseUrl).then((response) => {
        let options = response?.data?.states
          .sort((a, b) => (a?.name > b.name ? -1 : 1))
          .map((state) => ({
            label: state.name,
            value: state.name,
          }));
        setstateOptionDropDown(options);
      });
    };
    fetchData();
  }, []);

  return (
    <>
      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          password: "",
          address: "",
        }}
        validationSchema={agentSchema}
        onSubmit={(values, actions) => {
          const findSelectedStateLabel = stateOptionDropDown.filter(
            (state) => state.value == selectedStateOfOriginId
          );

          values.State = findSelectedStateLabel[0].label;
          dispatch(addAgent(values, actions));
          props.onClickYes();

          // navigate("/dashboard/reason");
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
          handleBlur,
        }) => (
          <Form onSubmit={handleSubmit}>
            <h3 className='text-danger text-center'>ADD AGENT</h3>
            <Row className='mt-4 col-md-12'>
              <Col className='mb-4' sm={12} md={12} xl={6}>
                <Form.Control
                  type='text'
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder='First Name'
                  name='first_name'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.first_name || ""}
                />
                {errors.first_name && touched.first_name ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.first_name}
                  </p>
                ) : null}
              </Col>
              <Col sm={12} md={12} xl={6}>
                <Form.Control
                  type='text'
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder='Last Name'
                  name='last_name'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.last_name || ""}
                />
                {errors.last_name && touched.last_name ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.last_name}
                  </p>
                ) : null}
              </Col>
            </Row>
            <Row className='mt-4 col-md-12'>
              <Col className='mb-4' sm={12} md={12} xl={6}>
                <Form.Control
                  type='email'
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder='Email'
                  name='email'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.bike_id || ""}
                />
                {errors.email && touched.email ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.email}
                  </p>
                ) : null}
              </Col>
              <Col sm={12} md={12} xl={6}>
                <Form.Control
                  type='password'
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder='Password'
                  name='password'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.dispatch_id || ""}
                />
                {errors.password && touched.password ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.password}
                  </p>
                ) : null}
              </Col>
            </Row>
            <Row className='mt-4 col-md-12'>
              <Col className='mb-4' sm={12} md={12} xl={6}>
                <Form.Control
                  type='text'
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder='Address'
                  name='address'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.dispatch_id || ""}
                />
                {errors.password && touched.password ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.password}
                  </p>
                ) : null}
              </Col>
              <Col className='mb-4' sm={12} md={12} xl={6}>
                <select
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder='State of Origin'
                  name='State'
                  // onChange={(option) => loadStateLGAOption(option)}
                  values={values.State}
                  onChange={(e) => {
                    const selectedStateId = e.currentTarget.value;
                    setselectedStateOfOriginId(selectedStateId);
                  }}
                  required
                >
                  <option>Select State</option>
                  {stateOptionDropDown
                    ?.sort((a, b) => (a?.label > b?.label ? 1 : -1))
                    ?.map((stateOption) => {
                      return (
                        <option
                          value={stateOption?.value}
                          label={stateOption?.label}
                          key={stateOption?.value}
                        >
                          {stateOption?.label}
                        </option>
                      );
                    })}
                </select>
              </Col>
            </Row>
            <Row>
              <Col className="mb-4" sm={12} md={12} xl={6}>
                <select
                  className={`${style.formInput} shadow-none form-control`}
                  onChange={(e) => setValue(e.target.value)}
                  value={value}
                  required
                >
                {options.map((value) => (
                  <option value={value} key={value}>{value}</option>
                ))}
                </select>
              </Col>
            </Row>
            <Row>
              <div className='d-flex justify-content-center mt-3'>
                <button
                  type='submit'
                  className={` shadow-none  ${style.actionBtn} ${style.reject}`}
                  style={{ background: props.btnColor }}
                >
                  {isSubmitting ? <SyncOutlined spin /> : "SUBMIT"}
                </button>
              </div>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CreateForm;
